import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { first, map, Observable } from 'rxjs';

import { ROUTES } from '../definitions/constants/routes.constants';
import { User } from '../definitions/interfaces/user/user';
import { UserConfigsStoreFacade } from '../stores/global-store/user-configs/user-configs-store.facade';

export const repEvolutionGuard = (): Observable<boolean | UrlTree> => {
  const userConfigsFacade = inject(UserConfigsStoreFacade);
  const router = inject(Router);

  return userConfigsFacade.user$.pipe(
    first((user): user is User => !!user),
    map((user: User) => {

      if (!userConfigsFacade.hasRepEvolutionAccessSignal()) return router.createUrlTree([ ROUTES.MAIN ]);
      if (!userConfigsFacade.repEvolutionStartedSignal()) userConfigsFacade.startRepEvolution(user);

      return true;
    })
  );
};
